import { CaretLeft, CaretRight, Trash, X } from "@phosphor-icons/react";
import { Button } from "./ui/button";

export function TransactionPagination({ page, pages, total, loading, onPage }) {
  return (
    <div className="flex flex-col gap-3 border-t border-border px-4 py-3 sm:flex-row sm:items-center sm:justify-between">
      <p className="text-xs text-muted-foreground tabular-nums">
        {total.toLocaleString()} transaction{total === 1 ? "" : "s"}
        <span className="mx-2 text-border">/</span>
        Page {page} of {pages}
      </p>
      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          size="sm"
          onClick={() => onPage(page - 1)}
          disabled={loading || page <= 1}
          className="gap-1.5 border-border"
          data-testid="transactions-previous-page"
        >
          <CaretLeft size={14} /> Previous
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={() => onPage(page + 1)}
          disabled={loading || page >= pages}
          className="gap-1.5 border-border"
          data-testid="transactions-next-page"
        >
          Next <CaretRight size={14} />
        </Button>
      </div>
    </div>
  );
}

export function BulkSelectionBar({ selectedCount, deleting, onClear, onDelete }) {
  if (!selectedCount) return null;
  return (
    <div className="flex flex-col gap-3 border-b border-expense/25 bg-expense/5 px-4 py-3 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex items-center gap-2">
        <span className="h-2 w-2 rounded-full bg-expense" aria-hidden="true" />
        <p className="text-sm font-semibold tabular-nums">
          {selectedCount.toLocaleString()} selected
        </p>
      </div>
      <div className="flex items-center gap-2">
        <Button variant="ghost" size="sm" onClick={onClear} disabled={deleting} className="gap-1.5">
          <X size={14} /> Clear
        </Button>
        <Button
          variant="destructive"
          size="sm"
          onClick={onDelete}
          disabled={deleting}
          className="gap-1.5"
          data-testid="bulk-delete-btn"
        >
          <Trash size={14} /> {deleting ? "Deleting…" : "Delete selected"}
        </Button>
      </div>
    </div>
  );
}
